import React from "react";

import { CButton, CBadge, CPopover } from "@coreui/react";
import {
  RiVidiconLine,
  RiCloseCircleLine,
  RiCheckboxCircleLine,
  RiErrorWarningLine,
  RiCheckboxMultipleFill
} from "react-icons/ri";
import { useSelector } from "react-redux";

import URL from "../../config/api";
import { friendlyDate } from "../../utils/date";

const DashboardListItem = ({ item, className }) => {
  const user = useSelector(state => state.user);
  const abilities = {};
  let abilitiesString = "";

  item?.items?.forEach(element => {
    if (element.los?.abilities && element.los.abilities.type === "bncc") {
      abilities[element.los.abilities.code] = element.los.abilities.description;
    }
  });
  Object.keys(abilities).forEach(key => {
    abilitiesString += `${key}: ${abilities[key]}\n`;
  });

  const to = `/activity/${item.type_id === 2 ? "live" : "do"}/${
    item.allocation_id
  }`;

  let bgColor;
  let Icon;

  if (item.user_id === user.user.id) {
    bgColor = "primary";
    Icon = RiCheckboxMultipleFill;
  } else if (item.type_id === 2) {
    bgColor = "aquamarine";
    Icon = RiVidiconLine;
  } else if (item.activity_percentage >= 100) {
    bgColor = "success";
    Icon = RiCheckboxCircleLine;
  } else if (new Date(item.activity_end) < new Date()) {
    bgColor = "danger";
    Icon = RiCloseCircleLine;
  } else {
    bgColor = "warning";
    Icon = RiErrorWarningLine;
  }

  return (
    <CButton
      to={to}
      color="white"
      className={`p-0 d-flex w-100 border-default ${className || ""}`}
    >
      <div
        className="d-flex align-items-center w-100"
        target={item.type_id === 2 ? "_blank" : null}
      >
        <div
          className={`d-flex align-items-center rounded-left justify-content-center text-white bg-${bgColor}`}
          style={{ height: "5rem", width: "5rem", fontSize: "2.25rem" }}
        >
          <Icon />
        </div>
        <div
          className="flex-1 d-flex align-items-center text-ellipsis px-4"
          style={{ fontSize: "1rem" }}
        >
          <div
            className="d-none d-lg-flex align-items-center text-left mr-4"
            style={{ flex: 1, fontWeight: "bold" }}
          >
            <div className="c-avatar mr-3">
              <img
                className="c-avatar-img"
                alt=""
                src={
                  URL.img +
                  (item.user_photo || "uploads/users/profileEmpty.jpg")
                }
              />
            </div>
            <span>{item.user_name}</span>
          </div>
          <div className="d-flex flex-column text-ellipsis" style={{ flex: 2 }}>
            <div
              className="text-ellipsis text-left"
              style={{ flex: 1, fontWeight: "bold" }}
            >
              {item.name}
            </div>
            <div
              className="text-muted text-ellipsis text-left small"
              style={{ flex: 1 }}
            >
              Acaba em {friendlyDate(item.activity_end)}
            </div>
          </div>
          <div className="d-flex flex-column justify-content-between align-items-end">
            {item.discipline_name && (
              <CBadge color="primary">{item.discipline_name}</CBadge>
            )}
            {Object.keys(abilities).length > 0 && (
              <CPopover placement="bottom" content={abilitiesString}>
                <CBadge color="primary" className="mt-2">
                  Habilidades
                </CBadge>
              </CPopover>
            )}
          </div>
        </div>
      </div>
    </CButton>
  );
};

export default DashboardListItem;
